












import { Vue, Component } from "vue-property-decorator";

import DetectLang from "@/utils/DetectLang.vue";

import Nav from "@/views/Nav.vue";
import Sidebar from "@/views/Sidebar.vue";
import Footer from "@/views/Footer.vue";

@Component({
  name: "App",
  components: { DetectLang, Nav, Sidebar, Footer }
})
export default class App extends Vue {}
